import styled from 'styled-components';

import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';
import { rem } from '@savgroup-front-common/primitive/helpers/units';

export const $AvailablePlanContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr repeat(3, 1fr);
  gap: ${spacing('lg')};

  margin-bottom: ${spacing('sm')};

  & > * {
    overflow: hidden;
  }
`;

export const $ChoosePricingHeader = styled.header`
  margin-bottom: ${spacing('xxl')};
`;

export const $ChoosePricingContainer = styled.div<{ isFromScratch?: boolean }>`
  padding: ${({ isFromScratch }) =>
    isFromScratch ? 0 : `${spacing('xxl')} ${rem(120)}`};
`;

export const $EmptyColumn = styled.div``;
